import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v0/access-token';

export class AccessTokenService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async createAccessToken(
    params: types.CreateAccessTokenParameters,
  ): Promise<types.CreateAccessTokenResponse> {
    const { data } = await this.axios.post<types.CreateAccessTokenResponse>(
      'accesstokens',
      params.body,
    );
    return data;
  }
  decipherAccessToken(
    params: types.DecipherAccessTokenParameters,
  ): Promise<types.DecipherAccessTokenResponse> {
    throw new Error('Method not implemented.');
  }
}
